import { Eye } from 'lucide-react';

import crossIcon from '@/assets/icons/crossIcon.svg';
import deleteIcon from '@/assets/icons/deleteIcon.svg';
import retryIcon from '@/assets/icons/retryIcon.svg';
import { FileName } from '@/components/ui/file-name';
import { IconButton } from '@/components/ui/icon-button';
import { StatusChip, type StatusType } from '@/components/ui/status-chip';

export type FileStatus = StatusType;

interface FileCardProps {
  fileName: string;
  id: string;
  onCancel?: () => void;
  onDelete?: () => void;
  onRetry?: () => void;
  onView?: () => void;
  status: FileStatus;
}

export function FileCard({ fileName, onCancel, onDelete, onRetry, onView, status }: FileCardProps) {
  return (
    <div className="group hover:bg-back-bg2 flex cursor-pointer items-center justify-between gap-2 px-3 py-1.5 transition-colors">
      {/* File name with tooltip */}
      <div className="relative min-w-0 flex-1">
        <FileName fileName={fileName} />
      </div>

      {/* Status badge */}
      <StatusChip status={status} />

      {/* Action buttons */}
      <div className="flex shrink-0 items-center gap-2">
        {status === 'processing' && onCancel && (
          <IconButton aria-label="Cancel" onClick={onCancel}>
            <img alt="Cancel" className="icon-themed h-8 w-8" src={crossIcon} />
          </IconButton>
        )}

        {status === 'done' && (
          <>
            {/* Removing view icon as asked by product team */}
            {onView && (
              <IconButton aria-label="View" onClick={onView}>
                <Eye className="text-foreground h-4 w-4" />
              </IconButton>
            )}
            {onDelete && (
              <IconButton aria-label="Delete" onClick={onDelete}>
                <img alt="Delete" className="icon-themed h-4 w-4" src={deleteIcon} />
              </IconButton>
            )}
          </>
        )}

        {status === 'failed' && onRetry && (
          <IconButton aria-label="Retry" className="rounded-full" onClick={onRetry}>
            <img alt="Retry" className="icon-themed h-8 w-8" src={retryIcon} />
          </IconButton>
        )}
      </div>
    </div>
  );
}
